import { FaTiktok, FaFacebook, FaLinkedin, FaInstagram } from "react-icons/fa";

export const company_info = [
    {
      email: {
        email1: "medcables@hotmail.com",
        email2: "Info@med-cables.com"
      },
      whatsapp_number: "+9617420830",
      phone: {
        phone1: "+9617420830",
        phone2: "+9617420850",
        phone3: "+9617420840",
      },
      address: {
        name: "Med cables, Tefahta, Lebanon",
        lat: 33.45133343518141, 
        lng: 35.361417915341946
      },
      footer_description: "Innovative solutions for your business needs. Committed to excellence and customer satisfaction.",
      about_description: "Mediterranean Cables is a leading manufacturer of high-quality cables for a variety of industries, with over 14 years of experience. We've built a reputation for providing reliable, durable, and cost-effective solutions that meet the needs of our clients. Our state-of-the-art facility and advanced technology allow us to produce cables that meet the highest standards for performance, reliability, and safety.",
      the_four_features: [
        {
          icon: "💰",
          title: "Competitive Pricing",
          desc: "Best value for your budget",
        },
        {
          icon: "⏱️",
          title: "On-Time, Every Time",
          desc: "Reliable delivery schedules",
        },
        {
          icon: "✅",
          title: "ISO Certified",
          desc: "Standards you can trust",
        },
        {
          icon: "🛠️",
          title: "Advanced Testing",
          desc: "Reliable testing methods",
        }
      ],
      workingHours: [
        { days: "Monday - Friday", hours: "8:00 AM - 3:00 PM" },
        { days: "Saturday", hours: "8:00 AM - 2:00 PM" },
        { days: "Sunday", hours: "Closed" },
      ],
      socialLinks: [
        { icon: FaFacebook, url: "https://www.facebook.com/medcables" },
        { icon: FaTiktok, url: "https://www.tiktok.com/@medcables_1?_t=ZS-8u003gRKsqI&_r=1" },
        { icon: FaInstagram, url: "https://www.instagram.com/medcables_?igsh=Z2VicmoxcTJuYWhz" },
        { icon: FaLinkedin, url: "https://www.linkedin.com/company/90653767/admin/" },
      ]
    }
]